import { MenuItem, MenuSeparator, Text, Box } from '@chakra-ui/react';
import {
  MdEdit as EditIcon,
  MdDelete as DeleteIcon,
  MdCameraAlt as CameraIcon,
} from 'react-icons/md';

interface RecipeActionsMenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
  onChangePhoto?: () => void;
}

const itemStyles = {
  px: 3,
  py: '10px',
  gap: 3,
  borderRadius: 'md',
  _hover: { bg: 'bg.muted', cursor: 'pointer' },
} as const;

/**
 * Recipe-specific action menu items
 */
export default function RecipeActionsMenu({
  onEdit,
  onDelete,
  onChangePhoto,
}: RecipeActionsMenuProps) {
  return (
    <>
      {onEdit && (
        <MenuItem value="edit" onClick={onEdit} {...itemStyles}>
          <Box color="accent.secondary"><EditIcon size={16} /></Box>
          <Text fontFamily="body" fontWeight="500" fontSize="sm" color="text.primary">Edit Recipe</Text>
        </MenuItem>
      )}
      {onChangePhoto && (
        <MenuItem value="photo" onClick={onChangePhoto} {...itemStyles}>
          <Box color="accent.secondary"><CameraIcon size={16} /></Box>
          <Text fontFamily="body" fontWeight="500" fontSize="sm" color="text.primary">Change Photo</Text>
        </MenuItem>
      )}
      {onDelete && (
        <>
          <MenuSeparator borderColor="border.muted" mx={2} my={1} />
          <MenuItem value="delete" onClick={onDelete} {...itemStyles} _hover={{ bg: '#fff5f3', cursor: 'pointer' }}>
            <Box color="status.error"><DeleteIcon size={16} /></Box>
            <Text fontFamily="body" fontWeight="500" fontSize="sm" color="status.error">Delete Recipe</Text>
          </MenuItem>
        </>
      )}
    </>
  );
}
